import { useState } from 'react';
import { useIntl } from 'react-intl';
import { canvasService } from '../../../apiServices/CanvasService';
import { LabelLg, SelectInput } from '../../../components/Input/Input';
import { ConfirmModal } from '../../../components/Modal/ConfirmModal';
import { UserData } from '../../../context/User/useUser';

type AdminCopyProjectModalProps = {
  canvasId: string;
  canvasName: string;
  ownerUserId: number;
  ownerEmail: string;
  adminUsers: UserData[];
  onSuccess: () => void;
};

export const AdminCopyProjectModal = ({
  canvasId,
  canvasName,
  ownerUserId,
  ownerEmail,
  adminUsers,
  onSuccess,
}: AdminCopyProjectModalProps) => {
  const intl = useIntl();
  const [selectedUserId, setSelectedUserId] = useState(ownerUserId);

  const onCopy = () =>
    canvasService.adminCopyCanvas(canvasId, selectedUserId).then(() => {
      onSuccess();
      return intl.formatMessage({ id: 'admin.copyProject.successToast' });
    });

  return (
    <ConfirmModal
      title={intl.formatMessage({ id: 'admin.copyProject.title' })}
      confirmLabel={intl.formatMessage({ id: 'admin.copyProject.copyButton' })}
      confirmingLabel={intl.formatMessage({
        id: 'admin.copyProject.copyingButton',
      })}
      cancelLabel={intl.formatMessage({ id: 'admin.copyProject.cancelButton' })}
      onConfirm={onCopy}
    >
      <p>
        {intl.formatMessage(
          { id: 'admin.copyProject.description' },
          { name: <strong>{canvasName}</strong> }
        )}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <LabelLg htmlFor="copy-target-user">
          {intl.formatMessage({ id: 'admin.copyProject.assignLabel' })}
        </LabelLg>
        <SelectInput
          id="copy-target-user"
          value={selectedUserId}
          onChange={(e) => setSelectedUserId(Number(e.target.value))}
        >
          <option value={ownerUserId}>
            {intl.formatMessage(
              { id: 'admin.copyProject.ownerOption' },
              { email: ownerEmail }
            )}
          </option>
          {adminUsers
            .filter((u) => u.userId !== ownerUserId)
            .map((u) => (
              <option key={u.userId} value={u.userId}>
                {intl.formatMessage(
                  { id: 'admin.copyProject.adminOption' },
                  { email: u.email }
                )}
              </option>
            ))}
        </SelectInput>
      </div>
    </ConfirmModal>
  );
};
